import { parseEnforceKycFromPayload } from "@utils/parseEnforceKyc";

export default class PaySession {
  readonly globalMessage: string;
  readonly redirectPaymentUrl: string;
  readonly refreshCheckoutPage: boolean;
  readonly state: "redirect" | "failed" | "refresh" | "wait";
  /** Normalized from API `enforce_kyc` / nested envelope (see parseEnforceKycFromPayload). */
  readonly enforceKyc: boolean;

  constructor(data: { [x: string]: any }) {
    this.globalMessage = data.global_message;
    this.redirectPaymentUrl = data.redirect_payment_url;
    this.refreshCheckoutPage = data.refresh_checkout_page;
    this.state = data.state;
    this.enforceKyc = parseEnforceKycFromPayload(data);
  }
}
